import { ApiMethod } from '@wajeez-web/stores/base';
import axios from 'axios';

export const getUserCountry: ApiMethod<void, string | undefined> = async (
  _,
  { dispatch }
) => {
  try {
    const response = await axios.get<string>('https://ip2c.org/?self');

    return response.data;
  } catch (error: any) {
    return undefined;
  }
  return undefined;
};
